import React from 'react';

import { ContactInfoCard } from './components/ContactInfoCard/index';
import { Trans } from 'lingui-react';

import './contactInfo.css';

export const ContactInfo = props => {
  return (
    <div className="company-contact-info">
      <div className="title-card">
        <span className="title-number">3</span><Trans id="Contact Information"/>
      </div>
      <ContactInfoCard
        titleCard={<Trans id="Executive Board" />}
        name="executiveBoard"
        onInputChange={props.onInputChange}
        requiredCard={true}
        contactInfoMember={props.executiveBoard}
        validationMessages={props.validationMessages}
        {...props}
      />
      <p className="more-info"><Trans id="Are the following roles assigned in your company?" /></p>
      <ContactInfoCard
        titleCard={<Trans id="Data Protection Officer" />}
        name="dataProtectionOfficer"
        onSelectCard={props.selectContactPerson}
        hasRole={props.hasDataProtectionOfficer}
        onInputChange={props.onInputChange}
        requiredCard={false}
        requiredMark
        contactInfoMember={props.dataProtectionOfficer}
        validationMessages={props.validationMessages}
        {...props}
      />
      <ContactInfoCard
        titleCard={<Trans id="Information Security Officer" />}
        name="informationSecurityOfficer"
        onSelectCard={props.selectContactPerson}
        hasRole={props.hasInformationSecurityOfficer}
        onInputChange={props.onInputChange}
        requiredCard={false}
        requiredMark
        contactInfoMember={props.informationSecurityOfficer}
        validationMessages={props.validationMessages}
        {...props}
      />
      <ContactInfoCard
        titleCard={<Trans id="IT Responsible (internal)" />}
        name="itResponsible"
        onSelectCard={props.selectContactPerson}
        hasRole={props.hasItResponsible}
        onInputChange={props.onInputChange}
        requiredCard={false}
        requiredMark
        contactInfoMember={props.itResponsible}
        validationMessages={props.validationMessages}
        {...props}
      />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/screens/Company/components/ContactInfo/ContactInfo.js